import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";

export function getWebApiUrl(): string {
	if (isCapacitorPlatform()) {
		return WEBPACK_WEBSITE_URL;
	}
	return "";
}
